import { render, staticRenderFns } from "./Podcast.vue?vue&type=template&id=c8a9c572&"
import script from "./Podcast.vue?vue&type=script&lang=js&"
export * from "./Podcast.vue?vue&type=script&lang=js&"
import style0 from "./Podcast.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Podcast.vue"
export default component.exports